/* TITANOVA Halloween landing (layout/hw-halloween.liquid): reveals, torch, countdown, delivery dates, gallery,
   buy form, sticky bar and the mini cart drawer. */
(() => {
  "use strict";

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const HW = window.HW || {};
  const routes = HW.routes || {};
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ----------------------------------------------------------------- money */
  const formatMoney = (cents) => {
    const amount = cents / 100;
    const group = (value, decimals, thousands = ",", point = ".") => {
      const [whole, fraction] = value.toFixed(decimals).split(".");
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? point + fraction : "");
    };
    return (HW.moneyFormat || "${{amount}}").replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      if (key === "amount_no_decimals") return group(amount, 0);
      if (key === "amount_with_comma_separator") return group(amount, 2, ".", ",");
      if (key === "amount_no_decimals_with_comma_separator") return group(amount, 0, ".", ",");
      return group(amount, 2);
    });
  };

  /* --------------------------------------------------------------- in view */
  const onView = (el, cb, rootMargin = "0px 0px -12% 0px") => {
    if (!("IntersectionObserver" in window)) return cb();
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          io.disconnect();
          cb();
        }
      },
      { rootMargin }
    );
    io.observe(el);
  };

  /** Wrap every word (also inside <em>) so headings rise in word by word. */
  const splitWords = (el) => {
    let i = 0;
    const walk = (node) => {
      Array.from(node.childNodes).forEach((child) => {
        if (child.nodeType === 1) return walk(child);
        if (child.nodeType !== 3) return;
        const frag = document.createDocumentFragment();
        child.textContent.split(/(\s+)/).forEach((part) => {
          if (!part) return;
          if (/^\s+$/.test(part)) return frag.appendChild(document.createTextNode(" "));
          const word = document.createElement("span");
          const inner = document.createElement("span");
          word.className = "hw-word";
          inner.textContent = part;
          inner.style.setProperty("--i", i++);
          word.appendChild(inner);
          frag.appendChild(word);
        });
        child.replaceWith(frag);
      });
    };
    walk(el);
  };

  $$("[data-hw-split]").forEach((el) => {
    splitWords(el);
    onView(el, () => el.classList.add("is-in"), "0px");
  });
  $$("[data-hw-reveal]").forEach((el) => onView(el, () => el.classList.add("is-in")));
  $$("[data-hw-stagger]").forEach((el) => {
    Array.from(el.children).forEach((child, i) => child.style.setProperty("--i", i));
    onView(el, () => el.classList.add("is-in"));
  });

  /* -------------------------------------------------------------- parallax */
  const parallax = $$("[data-hw-parallax]");
  if (parallax.length && !reduce) {
    let ticking = false;
    const update = () => {
      ticking = false;
      const y = window.scrollY;
      parallax.forEach((el) => (el.style.translate = "0 " + (y * parseFloat(el.dataset.hwParallax)).toFixed(1) + "px"));
    };
    window.addEventListener(
      "scroll",
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      },
      { passive: true }
    );
  }

  /* ----------------------------------------------------------------- torch */
  $$("[data-hw-torch]").forEach((el) => {
    let idle;
    const move = (e) => {
      const r = el.getBoundingClientRect();
      el.style.setProperty("--hw-x", (((e.clientX - r.left) / r.width) * 100).toFixed(1) + "%");
      el.style.setProperty("--hw-y", (((e.clientY - r.top) / r.height) * 100).toFixed(1) + "%");
      el.classList.add("is-manual");
      clearTimeout(idle);
      idle = setTimeout(() => el.classList.remove("is-manual"), 2600);
    };
    el.addEventListener("pointermove", move);
    el.addEventListener("pointerdown", move);
  });

  /* ------------------------------------------------------------- countdown */
  $$("[data-hw-countdown]").forEach((el) => {
    const target = new Date(el.dataset.hwCountdown).getTime();
    if (Number.isNaN(target)) return;
    const units = [["d", 864e5], ["h", 36e5], ["m", 6e4], ["s", 1e3]];
    const tick = () => {
      let left = target - Date.now();
      if (left <= 0) {
        el.hidden = true;
        return false;
      }
      units.forEach(([key, ms]) => {
        const value = Math.floor(left / ms);
        left -= value * ms;
        const node = $('[data-u="' + key + '"]', el);
        if (node) node.textContent = String(value).padStart(2, "0");
      });
      return true;
    };
    if (tick()) {
      const timer = setInterval(() => tick() || clearInterval(timer), 1000);
    }
  });

  /* ------------------------------------------------------ delivery estimate */
  const product = (() => {
    const script = $("[data-hw-product]");
    try {
      return script ? JSON.parse(script.textContent) : null;
    } catch (e) {
      return null;
    }
  })();

  const addBusinessDays = (from, days) => {
    const d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) added++;
    }
    return d;
  };

  if (product && product.shipMax > 0) {
    const fmt = (d) => d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
    const today = new Date();
    const min = addBusinessDays(today, product.shipMin);
    const max = addBusinessDays(today, product.shipMax);
    $$("[data-hw-eta]").forEach((el) => (el.textContent = "Estimated arrival " + fmt(min) + " – " + fmt(max)));

    /* Latest order day whose slowest delivery still lands by Oct 30, so it is there before Halloween night. */
    const year = today.getFullYear();
    const deadline = new Date(year, 9, 30);
    let cutoff = null;
    for (let d = new Date(year, 9, 30); d.getMonth() >= 8; d.setDate(d.getDate() - 1)) {
      if (addBusinessDays(d, product.shipMax) <= deadline) {
        cutoff = new Date(d);
        break;
      }
    }
    const startOfToday = new Date(year, today.getMonth(), today.getDate());
    if (cutoff && cutoff >= startOfToday) {
      $$("[data-hw-cutoff]").forEach((el) => (el.textContent = fmt(cutoff)));
      $$("[data-hw-cutoff-wrap]").forEach((el) => (el.hidden = false));
    }
  }

  /* --------------------------------------------------------------- gallery */
  $$("[data-hw-gallery]").forEach((gallery) => {
    const slides = $$("[data-hw-slide]", gallery);
    const thumbs = $$("[data-hw-thumb]", gallery);
    if (slides.length < 2) return;
    let current = 0;
    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((s, i) => s.classList.toggle("is-active", i === current));
      thumbs.forEach((t, i) => {
        t.classList.toggle("is-active", i === current);
        t.setAttribute("aria-current", i === current ? "true" : "false");
      });
      const thumb = thumbs[current];
      if (thumb) thumb.parentElement.scrollTo({ left: thumb.offsetLeft - thumb.parentElement.clientWidth / 2 + thumb.clientWidth / 2, behavior: reduce ? "auto" : "smooth" });
    };
    thumbs.forEach((t, i) => t.addEventListener("click", () => show(i)));
    $$("[data-hw-prev]", gallery).forEach((b) => b.addEventListener("click", () => show(current - 1)));
    $$("[data-hw-next]", gallery).forEach((b) => b.addEventListener("click", () => show(current + 1)));
    const main = $("[data-hw-main]", gallery);
    let startX = null;
    main.addEventListener("pointerdown", (e) => {
      if (!e.target.closest("button")) startX = e.clientX;
    });
    main.addEventListener("pointerup", (e) => {
      if (startX === null) return;
      const dx = e.clientX - startX;
      startX = null;
      if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
    });
    main.addEventListener("pointercancel", () => (startX = null));
  });

  /* ------------------------------------------------------------------ cart */
  const cart = $("[data-hw-cart]");
  let lastFocus = null;

  const setCount = (count) =>
    $$("[data-hw-cart-count]").forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });

  const renderCart = (data) => {
    setCount(data.item_count);
    if (!cart) return;
    const list = $("[data-hw-cart-lines]", cart);
    list.textContent = "";
    if (!data.items.length) {
      const empty = document.createElement("li");
      empty.className = "hw-cart__empty";
      empty.textContent = "Your cart is empty.";
      list.appendChild(empty);
    }
    data.items.forEach((item) => {
      const li = document.createElement("li");
      li.className = "hw-line";
      const img = document.createElement("img");
      img.alt = "";
      img.loading = "lazy";
      if (item.image) img.src = item.image + (item.image.includes("?") ? "&" : "?") + "width=160";
      const info = document.createElement("div");
      const title = document.createElement("div");
      title.className = "hw-line__title";
      title.textContent = item.product_title;
      const meta = document.createElement("div");
      meta.className = "hw-line__meta";
      meta.textContent = "Qty " + item.quantity + (item.variant_title ? " · " + item.variant_title : "");
      const remove = document.createElement("button");
      remove.type = "button";
      remove.className = "hw-line__remove";
      remove.textContent = "Remove";
      remove.addEventListener("click", () => changeLine(item.key, 0));
      info.append(title, meta, remove);
      const price = document.createElement("div");
      price.className = "hw-line__price";
      price.textContent = formatMoney(item.final_line_price);
      li.append(img, info, price);
      list.appendChild(li);
    });
    $("[data-hw-cart-total]", cart).textContent = formatMoney(data.total_price);
    $("[data-hw-cart-foot]", cart).hidden = !data.items.length;
  };

  const fetchCart = () => fetch((routes.cart || "/cart") + ".js", { headers: { Accept: "application/json" } }).then((r) => r.json());

  const changeLine = (key, quantity) =>
    fetch((routes.cartChange || "/cart/change") + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity }),
    })
      .then((r) => r.json())
      .then(renderCart);

  const closeCart = () => {
    if (!cart || cart.hidden) return;
    cart.classList.remove("is-open");
    document.documentElement.style.overflow = "";
    setTimeout(() => (cart.hidden = true), reduce ? 0 : 450);
    if (lastFocus) lastFocus.focus();
  };

  const openCart = async () => {
    if (!cart) {
      window.location.href = routes.cart || "/cart";
      return;
    }
    renderCart(await fetchCart());
    lastFocus = document.activeElement;
    cart.hidden = false;
    document.documentElement.style.overflow = "hidden";
    requestAnimationFrame(() => requestAnimationFrame(() => cart.classList.add("is-open")));
    const close = $("[data-hw-cart-close]", cart);
    if (close) close.focus();
  };

  if (cart) {
    $$("[data-hw-cart-close]", cart).forEach((b) => b.addEventListener("click", closeCart));
    document.addEventListener("keydown", (e) => e.key === "Escape" && closeCart());
  }
  $$("[data-hw-open-cart]").forEach((link) =>
    link.addEventListener("click", (e) => {
      e.preventDefault();
      openCart();
    })
  );

  /* -------------------------------------------------------------- buy form */
  const form = $("[data-hw-form]");
  if (form && product) {
    const qty = $("[data-hw-qty]", form);
    const idField = $("[name='id']", form);
    const select = $("select[name='id']", form);
    const error = $("[data-hw-error]", form);
    const unitPrice = () => (select ? Number(select.selectedOptions[0].dataset.price) : product.price);
    const clamp = (n) => Math.max(1, Math.min(10, Math.round(n) || 1));
    const sync = () => {
      qty.value = clamp(Number(qty.value));
      const total = formatMoney(unitPrice() * Number(qty.value));
      $$("[data-hw-total]").forEach((el) => (el.textContent = total));
      if (select) $$("[data-hw-price]").forEach((el) => (el.textContent = formatMoney(unitPrice())));
    };
    $$("[data-hw-step]", form).forEach((b) =>
      b.addEventListener("click", () => {
        qty.value = clamp(Number(qty.value) + Number(b.dataset.hwStep));
        sync();
      })
    );
    qty.addEventListener("change", sync);
    if (select) select.addEventListener("change", sync);
    sync();

    const addToCart = async () => {
      const res = await fetch((routes.cartAdd || "/cart/add") + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(idField.value), quantity: Number(qty.value) || 1 }] }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.description || data.message || "We couldn't add this to your cart. Try again.");
      }
    };
    const run = async (button, after) => {
      if (!button || button.disabled) return;
      button.disabled = true;
      button.classList.add("is-loading");
      if (error) error.hidden = true;
      try {
        await addToCart();
        await after();
      } catch (err) {
        if (error) {
          error.textContent = err.message;
          error.hidden = false;
        }
      } finally {
        button.disabled = false;
        button.classList.remove("is-loading");
      }
    };

    const atc = $("[data-hw-atc]", form);
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      run(atc, openCart);
    });
    const buyNow = $("[data-hw-buynow]", form);
    if (buyNow) buyNow.addEventListener("click", () => run(buyNow, () => (window.location.href = "/checkout")));
    $$("[data-hw-sticky-add]").forEach((b) => b.addEventListener("click", () => run(b, openCart)));

    /* Sticky bar: only while the hero and the buy box are both off screen. */
    const sticky = $("[data-hw-sticky]");
    const hero = $("[data-hw-hero]");
    if (sticky && "IntersectionObserver" in window) {
      let heroVisible = !!hero;
      let formVisible = true;
      const update = () => {
        const show = !heroVisible && !formVisible;
        sticky.classList.toggle("is-visible", show);
        sticky.setAttribute("aria-hidden", show ? "false" : "true");
        sticky.inert = !show;
      };
      if (hero) new IntersectionObserver(([e]) => ((heroVisible = e.isIntersecting), update())).observe(hero);
      new IntersectionObserver(([e]) => ((formVisible = e.isIntersecting), update())).observe(form);
    }
  }

  /* ---------------------------------------------------------------- scenes */
  $$("[data-hw-scroller]").forEach((wrap) => {
    const track = $("[data-hw-track]", wrap);
    if (!track) return;
    const step = () => {
      const first = track.firstElementChild;
      return first ? first.getBoundingClientRect().width + 18 : 320;
    };
    $$("[data-hw-scroll]", wrap).forEach((b) =>
      b.addEventListener("click", () => track.scrollBy({ left: step() * Number(b.dataset.hwScroll), behavior: reduce ? "auto" : "smooth" }))
    );
  });

  if (!reduce && window.matchMedia("(hover: hover)").matches) {
    $$("[data-hw-tilt]").forEach((card) => {
      card.addEventListener("pointermove", (e) => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = "perspective(900px) rotateY(" + (x * 9).toFixed(2) + "deg) rotateX(" + (-y * 9).toFixed(2) + "deg) translateY(-4px)";
      });
      card.addEventListener("pointerleave", () => (card.style.transform = ""));
    });
  }
})();
